import { render } from "./thirdstepGrooming.vue?vue&type=template&id=4b930a75&scoped=true"
import script from "./thirdstepGrooming.vue?vue&type=script&lang=js"
export * from "./thirdstepGrooming.vue?vue&type=script&lang=js"

import "./thirdstepGrooming.vue?vue&type=style&index=0&id=4b930a75&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b930a75"]])

export default __exports__